import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { FILTER_STATUS_OPTIONS } from "../../../sections/@dashboard/files/FileDataTable/fileDataTableUtils";

function FileDataStatusSelect({ control }) {
  return (
    <Controller
      name="status"
      control={control}
      rules={{
        required: true,
      }}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth>
          <InputLabel>Status</InputLabel>
          <Select {...field} label="Status" error={error && true}>
            {FILTER_STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText error>
            {error && "Bitte einen Status auswählen"}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
}

FileDataStatusSelect.propTypes = {
  control: PropTypes.object,
};

export default FileDataStatusSelect;
